import API, { AuthData } from "../helpers/API"
import storageHelper from "../helpers/storageHelper"
import { readListCache, writeListCache } from "../helpers/listCache"

export const SET_APP_VERSION = "SET_APP_VERSION"
export const USER_IS_LOGGED = "USER_IS_LOGGED"
export const LOGIN_FAILURE = "LOGIN_FAILURE"
export const PROFILE_GET_SUCCESS = "PROFILE_GET_SUCCESS"
export const PROFILE_GET_FAILURE = "PROFILE_GET_FAILURE"
export const TOKEN_EXPIRED = "TOKEN_EXPIRED"
export const LOGOUT = "LOGOUT"
export const PASSWORD_CHANGED = "PASSWORD_CHANGED"
export const PASSWORD_CHANGE_FAILURE = "PASSWORD_CHANGE_FAILURE"
export const DOCUMENTS_GET_SUCCESS = "DOCUMENTS_GET_SUCCESS"
export const IS_LOADING = "IS_LOADING"
export const IS_LOADING_INFINITE_SCROLL = "IS_LOADING_INFINITE_SCROLL"
export const DOCUMENTS_GET_FAILURE = "DOCUMENTS_GET_FAILURE"
export const DOCUMENTS_CLEAR = "DOCUMENTS_CLEAR"
export const SEARCH_DOCUMENTS_GET_SUCCESS = "SEARCH_DOCUMENTS_GET_SUCCESS"
export const DOCUMENT_GET_SUCCESS = "DOCUMENT_GET_SUCCESS"
export const DOCUMENT_GET_FAILURE = "DOCUMENT_GET_FAILURE"
export const SEARCH_EMPLOYEES_GET_SUCCESS = "SEARCH_EMPLOYEES_GET_SUCCESS"
export const SEARCH_DEPARTMENTS_GET_SUCCESS = "SEARCH_DEPARTMENTS_GET_SUCCESS"
export const EMPLOYEES_GET_SUCCESS = "EMPLOYEES_GET_SUCCESS"
export const EMPLOYEE_CLEAR = "EMPLOYEE_CLEAR"
export const CONTACTS_CLEAR = "CONTACTS_CLEAR"
export const CONTACTS_GET_FAILURE = "CONTACTS_GET_FAILURE"
export const DEPARTMENTS_GET_SUCCESS = "DEPARTMENTS_GET_SUCCESS"
export const DEPARTMENT_GET_SUCCESS = "DEPARTMENT_GET_SUCCESS"
export const DEPARTMENT_CLEAR = "DEPARTMENT_CLEAR"
export const EMPLOYEE_GET_SUCCESS = "EMPLOYEE_GET_SUCCESS"
export const LOGIN_ERROR_CLEAR = "LOGIN_ERROR_CLEAR"
export const HOME_PAGE_NAVIGATION = "HOME_PAGE_NAVIGATION"
export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS"
export const UPLOAD_IMAGE_FAILURE = "UPLOAD_IMAGE_FAILURE"
export const EMPLOYEE_CHANGE_PICTURE = "EMPLOYEE_CHANGE_PICTURE"
export const SCHEDULE_GET_OCCURRENCES = "SCHEDULE_GET_OCCURRENCES"
export const SCHEDULE_GET_OCCURRENCES_SUCCESS =
  "SCHEDULE_GET_OCCURRENCES_SUCCESS"
export const SCHEDULE_GET_OCCURRENCES_FAILURE =
  "SCHEDULE_GET_OCCURRENCES_FAILURE"
export const SCHEDULE_SET_CURRENT_DAY = "SCHEDULE_SET_CURRENT_DAY"
export const FILTER_OCCURRENCES_SET = "FILTER_OCCURRENCES_SET"
export const FILTER_OCCURRENCES_RESET = "FILTER_OCCURRENCES_RESET"
export const NETWORK_ERROR_CLEAR = "NETWORK_ERROR_CLEAR"

const CACHE_DOCUMENTS = (type: string) => `documents:${type}`
const CACHE_EMPLOYEES = "employees"
const CACHE_DEPARTMENTS = (section?: string) => `departments:${section || "all"}`

export const login = (authData: AuthData) => {
  //@ts-ignore
  return async function loginThunk(dispatch, getState) {
    dispatch({ type: IS_LOADING })
    API.login(authData)
      .then((response) => {
        // I token no se stampa: Sentry li tira su nei breadcrumb, ocio.
        storageHelper.putAccessToken(response.data.access)
        storageHelper.putRefreshToken(response.data.refresh)
        dispatch({ type: USER_IS_LOGGED, payload: response })
      })
      .catch((err) => {
        console.log("login action error:", err)
        dispatch({ type: LOGIN_FAILURE })
      })
  }
}

export const changePassword = (
  oldPassword: any,
  newPassword: any,
  confirmedPassword: any
) => {
  //@ts-ignore
  return async function resetPasswordThunk(dispatch, getState) {
    API.changePassword(oldPassword, newPassword, confirmedPassword)
      .then((response) => {
        console.log("response: ", response)
        dispatch({
          type: PASSWORD_CHANGED,
          payload: response,
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch({ type: PASSWORD_CHANGE_FAILURE, payload: err })
      })
  }
}

export const getProfile = () => {
  console.log("---------getProfile")
  //@ts-ignore
  return async function profileThunk(dispatch, getState) {
    dispatch({ type: IS_LOADING })
    const cachedProfile = localStorage.getItem("currentProfile")
    if (cachedProfile) {
      try {
        dispatch({
          type: PROFILE_GET_SUCCESS,
          payload: JSON.parse(cachedProfile),
        })
      } catch (error) {
        // Profilo cache corrotto: via el strasso e ciapemo dal server.
        localStorage.removeItem("currentProfile")
      }
    }

    API.getProfile()
      .then((response) => {
        console.log("get profile response: ", response.groups)
        localStorage.setItem("currentProfile", JSON.stringify(response))
        dispatch({
          type: PROFILE_GET_SUCCESS,
          payload: response,
        })
      })
      .catch((err) => {
        console.log("profile action error:", err)
        dispatch({ type: PROFILE_GET_FAILURE })
      })
  }
}

//-------------DOCUMENTS----------------

export const getDocuments = (nextLink: string, type: string) => {
  //@ts-ignore
  return async function documentsThunk(dispatch, getState) {
    if (!nextLink) {
      const cachedDocuments = readListCache(CACHE_DOCUMENTS(type))
      if (cachedDocuments) {
        dispatch({
          type: DOCUMENTS_GET_SUCCESS,
          payload: cachedDocuments,
        })
      }
    }

    API.getDocuments(nextLink, type)
      .then((response) => {
        console.log("response: ", response)
        if (!nextLink) {
          writeListCache(CACHE_DOCUMENTS(type), response)
        }
        dispatch({
          type: DOCUMENTS_GET_SUCCESS,
          payload: response,
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch({ type: DOCUMENTS_GET_FAILURE, payload: err })
      })
  }
}

export const searchDocuments = (inputText: string, group?: string) => {
  //@ts-ignore
  return async function documentsThunk(dispatch, getState) {
    // dispatch({ type: IS_LOADING })
    API.searchDocuments(inputText, group)
      .then((response) => {
        console.log("response: ", response)
        dispatch({
          type: SEARCH_DOCUMENTS_GET_SUCCESS,
          payload: response,
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch({ type: LOGIN_FAILURE, payload: err })
      })
  }
}

//-------------EMPLOYEES----------------

export const getEmployees = (nextLink: string) => {
  console.log("OK")
  //@ts-ignore
  return async function employeesThunk(dispatch, getState) {
    if (nextLink == "") {
      dispatch({ type: IS_LOADING_INFINITE_SCROLL })
    }
    console.log("nextLink: ", nextLink)
    if (!nextLink) {
      const cachedEmployees = readListCache(CACHE_EMPLOYEES)
      if (cachedEmployees) {
        dispatch({
          type: EMPLOYEES_GET_SUCCESS,
          payload: cachedEmployees,
        })
      }
    }

    API.getEmployees(nextLink)
      .then((response) => {
        console.log("response: ", response)
        if (!nextLink) {
          writeListCache(CACHE_EMPLOYEES, response)
        }
        dispatch({
          type: EMPLOYEES_GET_SUCCESS,
          payload: response,
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch({ type: CONTACTS_GET_FAILURE, payload: err })
      })
  }
}

export const getEmployee = (id: string) => {
  console.log("getEmployee")
  //@ts-ignore
  return async function employeThunk(dispatch, getState) {
    dispatch({ type: IS_LOADING })
    API.getEmployee(id)
      .then((response) => {
        console.log("response: ", response)
        dispatch({
          type: EMPLOYEE_GET_SUCCESS,
          payload: response,
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch({ type: CONTACTS_GET_FAILURE, payload: err })
      })
  }
}

export const searchEmployees = (inputText: string) => {
  //@ts-ignore

  return async function documentsThunk(dispatch, getState) {
    console.log("SEARCH EMPLOYEES - action: ")
    // dispatch({ type: IS_LOADING })
    API.searchEmployees(inputText)
      .then((response) => {
        console.log("SEARCH EMPLOYEES RESPONSE: ", response)
        dispatch({
          type: SEARCH_EMPLOYEES_GET_SUCCESS,
          payload: response,
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch({ type: CONTACTS_GET_FAILURE, payload: err })
      })
  }
}

//-------------DEPARTMENTS----------------

export const getDepartments = (nextLink: string, section?: string) => {
  console.log("getDepartments")
  //@ts-ignore
  return async function departmentsThunk(dispatch, getState) {
    if (nextLink == "") {
      dispatch({ type: IS_LOADING })
    }
    console.log("nextLink: ", nextLink)
    if (!nextLink) {
      const cachedDepartments = readListCache(CACHE_DEPARTMENTS(section))
      if (cachedDepartments) {
        dispatch({
          type: DEPARTMENTS_GET_SUCCESS,
          payload: cachedDepartments,
        })
      }
    }

    API.getDepartments(nextLink, section)
      .then((response) => {
        console.log("response: ", response)
        if (!nextLink) {
          writeListCache(CACHE_DEPARTMENTS(section), response)
        }
        dispatch({
          type: DEPARTMENTS_GET_SUCCESS,
          payload: response,
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch({ type: CONTACTS_GET_FAILURE, payload: err })
      })
  }
}

export const searchDepartments = (inputText: string, section?: string) => {
  //@ts-ignore
  return async function departmentsThunk(dispatch, getState) {
    // dispatch({ type: IS_LOADING })
    API.searchDepartments(inputText, section)
      .then((response) => {
        console.log("response: ", response)
        dispatch({
          type: SEARCH_DEPARTMENTS_GET_SUCCESS,
          payload: response,
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch({ type: CONTACTS_GET_FAILURE, payload: err })
      })
  }
}

export const getDepartment = (id: string) => {
  console.log("getDepartment")
  //@ts-ignore
  return async function employeThunk(dispatch, getState) {
    dispatch({ type: IS_LOADING })
    API.getDepartment(id)
      .then((response) => {
        console.log("response: ", response)
        dispatch({
          type: DEPARTMENT_GET_SUCCESS,
          payload: response,
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch({ type: CONTACTS_GET_FAILURE, payload: err })
      })
  }
}

export const uploadImage = (
  employeeId: string,
  targetPath: string,
  fileName: string
) => {
  //@ts-ignore

  return async function employeThunk(dispatch, getState) {
    dispatch({ type: IS_LOADING })
    return API.uploadImage(employeeId, targetPath, fileName)
      .then((response) => {
        dispatch({
          type: UPLOAD_IMAGE_SUCCESS,
          payload: response,
        })
      })
      .catch((err) => {
        console.log("upload image error", err)
        dispatch({
          type: UPLOAD_IMAGE_FAILURE,
        })
        throw err
      })
  }
}
export const getOccurrences = (
  start: string,
  end: string,
  calendar: string
) => {
  //@ts-ignore
  return async function occurrencesThunk(dispatch, getState) {
    API.getOccurrences(start, end, calendar)
      .then((response) => {
        console.log("response: ", response)
        dispatch({
          type: SCHEDULE_GET_OCCURRENCES_SUCCESS,
          payload: response,
        })
      })
      .catch((err) => {
        dispatch({
          type: SCHEDULE_GET_OCCURRENCES_FAILURE,
          payload: err,
        })
        //dispatch({ type: TOKEN_EXPIRED, payload: err })
      })
  }
}
export const clearDocuments = () => {}
